
import marketing from '~/mixins/marketing'
export default {
  mixins: [marketing],
  layout: 'blank',
  auth: false,
  middleware: ['isUser'],
  head () {
    return {
      titleTemplate: this.$t('title.home'),
      meta: [{ hid: 'description', name: 'description', content: this.$t('meta.home') }],
      script: [{
        hid: 'home-faq',
        type: 'application/ld+json',
        // Escape '<' before bypassing HTML entity escaping for this JSON tag.
        // This keeps JSON valid and prevents embedded closing script tags.
        innerHTML: JSON.stringify(this.faqStructuredData).replace(/</g, '\\u003c')
      }],
      __dangerouslyDisableSanitizersByTagID: { 'home-faq': ['innerHTML'] },
      link: [
        { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
        { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossorigin: '' },
        { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700&display=swap' }
      ]
    }
  },
  computed: {
    faqItems () {
      return this.$t('home.faq_items').map((item, index) => ({
        question: item.question,
        answer: this.$t('home.faq_items.' + index + '.answer', { register_url: this.localePath('/register') })
      }))
    },
    faqStructuredData () {
      return {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        inLanguage: this.$i18n.locale,
        mainEntity: this.faqItems.map(item => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: { '@type': 'Answer', text: item.answer }
        }))
      }
    }
  },
  data () {
    return {
      benefits: [
        { icon: 'md/heart', title: 'thousands_of_users', text: 'every_day_new_users' },
        { icon: 'md/diamond-stone', title: 'totally_free', text: 'all_features_free' },
        { icon: 'md/account-multiple-check', title: 'only_real_accounts', text: 'accounts_constantly_verified' }
      ],
      safetyFeatures: [
        { icon: 'md/lock-check', text: 'ssl' },
        { icon: 'md/email-lock-outline', text: 'spam_filter' },
        { icon: 'md/account-check', text: 'fake_control' }
      ]
    }
  }
}
